import React, { FunctionComponent } from "react";
import { useEventContext } from "../../context/EventProvider";

const Footer: FunctionComponent = (props: any) => {
  const { event: { privacyText, privacyLink} } = useEventContext();
  return (
    <footer>
      <div className="footer-container">
        <div className="footer-logo-and-cta">
          <img src="https://cdn.ems.prod.upgather.com/uploads/GDIT_Logo_c7d5b7fdfe.svg" alt="GDIT Logo" />
            <br />
            <div className="footer-title">EMERGE: Operational Technology</div>
            
            <a href="https://fedscoop.com" target="_blank"><img src="https://cdn.ems.prod.upgather.com/uploads/presentedby_FS_white_4e43c0c94b.svg" alt="produced by FedScoop" className="fsfoot" /></a>
          </div>
          <div className="footer-contain-right">
        <div><span>#GDITEMERGE</span></div>
        <div className="footer-social-icons">
        <div className="icons"><a href="https://www.facebook.com/sharer/sharer.php?u=https://gditot.upgather.com" target="_blank"><img src="https://cdn.ems.prod.upgather.com/uploads/gdit_FB_5e894d7297.svg" alt="Facebook" /></a></div>
          <div className="icons"><a href="https://www.linkedin.com/sharing/share-offsite/?url=https://gditot.upgather.com" target="_blank"><img src="https://cdn.ems.prod.upgather.com/uploads/gdit_Linked_In_cadc83121b.svg" alt="LinkedIn" /></a></div>
          <div className="icons"><a href="http://www.twitter.com/share?url=https://gditot.upgather.com" target="_blank"><img src="https://cdn.ems.prod.upgather.com/uploads/gdit_X_624f07b50b.svg" alt="X" /></a></div>
          <div className="icons"><a href="mailto:events@scoopnewsgroup.com" target="_blank"><img src="https://cdn.ems.prod.upgather.com/uploads/gdit_Email_c87cf10dfc.svg" alt="Email" /></a></div>
          
        </div>
        <a href={privacyLink} target="_blank" className="privacy-policy">{privacyText}</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
